import { Link } from "react-router-dom";
import { ReactNode } from "react";
import { BOOKING_URL } from "@/config/booking";

interface BookingLinkProps {
  children: ReactNode;
  className?: string;
  onClick?: () => void;
}

/**
 * Smart link that opens the external booking page (Calendly etc.)
 * in a new tab when configured, otherwise falls back to /contact.
 */
const BookingLink = ({ children, className, onClick }: BookingLinkProps) => {
  if (BOOKING_URL) {
    return (
      <a
        href={BOOKING_URL}
        target="_blank"
        rel="noopener noreferrer"
        className={className}
        onClick={onClick}
      >
        {children}
      </a>
    );
  }

  return (
    <Link to="/contact" className={className} onClick={onClick}>
      {children}
    </Link>
  );
};

export default BookingLink;
